// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── TV Skeleton / Shimmer ─────────────────────────────── */

.tv-skeleton {
  flex: 1 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-xl, 24px);
  min-height: 0;
  animation: skeletonFadeIn 0.3s ease;
}

@keyframes skeletonFadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

/* Shared shimmer effect */
.tv-skel-line,
.tv-skel-circle,
.tv-skel-small-circle,
.tv-skel-metric,
.tv-skel-map,
.tv-skel-day {
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.04) 25%,
    rgba(255, 255, 255, 0.08) 50%,
    rgba(255, 255, 255, 0.04) 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.6s ease-in-out infinite;
  border-radius: var(--radius-md, 8px);
}

@keyframes shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ── Left column: location card skeleton ──────────────── */

.tv-skel-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-lg, 16px);
  padding: var(--spacing-xl, 24px);
  background: var(--bg-card, rgba(255,255,255,0.05));
  border-radius: var(--radius-lg, 12px);
  border: 1px solid var(--border-color, rgba(255,255,255,0.08));
}

.tv-skel-city {
  width: 60%;
  height: 28px;
}

.tv-skel-circle {
  width: 96px;
  height: 96px;
  border-radius: 50%;
}

.tv-skel-temp {
  width: 40%;
  height: 48px;
}

.tv-skel-desc {
  width: 50%;
  height: 18px;
}

.tv-skel-metrics {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--spacing-md, 12px);
  width: 100%;
  margin-top: var(--spacing-md, 12px);
}

.tv-skel-metric {
  height: 56px;
  border-radius: var(--radius-md, 8px);
}

/* ── Right column: map + forecast skeleton ────────────── */

.tv-skel-right {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg, 16px);
  min-height: 0;
}

.tv-skel-map {
  flex: 1 1;
  min-height: 300px;
  border-radius: var(--radius-lg, 12px);
  border: 1px solid var(--border-color, rgba(255,255,255,0.08));
}

.tv-skel-forecast {
  display: flex;
  gap: var(--spacing-md, 12px);
}

.tv-skel-day {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-sm, 8px);
  padding: var(--spacing-md, 12px) var(--spacing-sm, 8px);
  border-radius: var(--radius-md, 8px);
  border: 1px solid var(--border-color, rgba(255,255,255,0.08));
}

.tv-skel-day-label {
  width: 60%;
  height: 14px;
}

.tv-skel-small-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}

.tv-skel-day-temp {
  width: 50%;
  height: 14px;
}

/* ── Responsive ───────────────────────────────────────── */

@media (max-width: 1400px) {
  .tv-skeleton {
    grid-template-columns: 1fr;
  }

  .tv-skel-right {
    flex-direction: row;
  }

  .tv-skel-map {
    flex: 1 1;
    min-height: 250px;
  }

  .tv-skel-forecast {
    flex: 1 1;
    flex-direction: column;
  }
}

@media (max-width: 1200px) {
  .tv-skel-right {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TV/TVSkeleton.css"],"names":[],"mappings":"AAAA,6DAA6D;;AAE7D;EACE,SAAO;EACP,aAAa;EACb,8BAA8B;EAC9B,4BAA4B;EAC5B,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA,0BAA0B;AAC1B;;;;;;EAME;;;;;GAKC;EACD,0BAA0B;EAC1B,4CAA4C;EAC5C,oCAAoC;AACtC;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,4DAA4D;;AAE5D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,gCAAgC;EAChC,kDAAkD;EAClD,qCAAqC;EACrC,6DAA6D;AAC/D;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,4BAA4B;EAC5B,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA,4DAA4D;;AAE5D;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,qCAAqC;EACrC,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,uDAAuD;EACvD,oCAAoC;EACpC,6DAA6D;AAC/D;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA,4DAA4D;;AAE5D;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,iBAAiB;EACnB;;EAEA;IACE,SAAO;IACP,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* ── TV Skeleton / Shimmer ─────────────────────────────── */\n\n.tv-skeleton {\n  flex: 1;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--spacing-xl, 24px);\n  min-height: 0;\n  animation: skeletonFadeIn 0.3s ease;\n}\n\n@keyframes skeletonFadeIn {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n/* Shared shimmer effect */\n.tv-skel-line,\n.tv-skel-circle,\n.tv-skel-small-circle,\n.tv-skel-metric,\n.tv-skel-map,\n.tv-skel-day {\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0.04) 25%,\n    rgba(255, 255, 255, 0.08) 50%,\n    rgba(255, 255, 255, 0.04) 75%\n  );\n  background-size: 200% 100%;\n  animation: shimmer 1.6s ease-in-out infinite;\n  border-radius: var(--radius-md, 8px);\n}\n\n@keyframes shimmer {\n  0%   { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n/* ── Left column: location card skeleton ──────────────── */\n\n.tv-skel-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-lg, 16px);\n  padding: var(--spacing-xl, 24px);\n  background: var(--bg-card, rgba(255,255,255,0.05));\n  border-radius: var(--radius-lg, 12px);\n  border: 1px solid var(--border-color, rgba(255,255,255,0.08));\n}\n\n.tv-skel-city {\n  width: 60%;\n  height: 28px;\n}\n\n.tv-skel-circle {\n  width: 96px;\n  height: 96px;\n  border-radius: 50%;\n}\n\n.tv-skel-temp {\n  width: 40%;\n  height: 48px;\n}\n\n.tv-skel-desc {\n  width: 50%;\n  height: 18px;\n}\n\n.tv-skel-metrics {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--spacing-md, 12px);\n  width: 100%;\n  margin-top: var(--spacing-md, 12px);\n}\n\n.tv-skel-metric {\n  height: 56px;\n  border-radius: var(--radius-md, 8px);\n}\n\n/* ── Right column: map + forecast skeleton ────────────── */\n\n.tv-skel-right {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-lg, 16px);\n  min-height: 0;\n}\n\n.tv-skel-map {\n  flex: 1;\n  min-height: 300px;\n  border-radius: var(--radius-lg, 12px);\n  border: 1px solid var(--border-color, rgba(255,255,255,0.08));\n}\n\n.tv-skel-forecast {\n  display: flex;\n  gap: var(--spacing-md, 12px);\n}\n\n.tv-skel-day {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-sm, 8px);\n  padding: var(--spacing-md, 12px) var(--spacing-sm, 8px);\n  border-radius: var(--radius-md, 8px);\n  border: 1px solid var(--border-color, rgba(255,255,255,0.08));\n}\n\n.tv-skel-day-label {\n  width: 60%;\n  height: 14px;\n}\n\n.tv-skel-small-circle {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n}\n\n.tv-skel-day-temp {\n  width: 50%;\n  height: 14px;\n}\n\n/* ── Responsive ───────────────────────────────────────── */\n\n@media (max-width: 1400px) {\n  .tv-skeleton {\n    grid-template-columns: 1fr;\n  }\n\n  .tv-skel-right {\n    flex-direction: row;\n  }\n\n  .tv-skel-map {\n    flex: 1;\n    min-height: 250px;\n  }\n\n  .tv-skel-forecast {\n    flex: 1;\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 1200px) {\n  .tv-skel-right {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
